import { Node } from '@tiptap/core';
import { mergeAttributes, ReactNodeViewRenderer } from '@tiptap/react';
import { SupportedAudioFormats, SupportedVideoFormats, } from '../../config/constants';
import { Video as VideoComponent } from './Video';
export const Video = Node.create({
    name: 'video',
    inline: false,
    group: 'block',
    draggable: true,
    addOptions() {
        return {
            HTMLAttributes: {
                kamran: 1,
            },
        };
    },
    addAttributes() {
        return {
            src: {
                default: undefined,
                rendered: false,
            },
            id: {
                default: undefined,
                rendered: false,
            },
            type: {
                default: undefined,
                rendered: false,
            },
            loading: {
                default: false,
                rendered: false,
            },
        };
    },
    parseHTML: () => [
        {
            tag: 'video',
            getAttrs: dom => {
                if (typeof dom === 'string')
                    return {};
                const element = dom;
                const source = element.querySelector('source');
                return {
                    id: element.getAttribute('data-id'),
                    type: element.getAttribute('data-file-type') || SupportedVideoFormats[0],
                    src: element.getAttribute('src') || source.getAttribute('src'),
                };
            },
        },
        {
            tag: 'audio',
            getAttrs: dom => {
                if (typeof dom === 'string')
                    return {};
                const element = dom;
                const source = element.querySelector('source');
                return {
                    id: element.getAttribute('data-id'),
                    type: element.getAttribute('data-file-type') || SupportedAudioFormats[0],
                    src: element.getAttribute('src') || source.getAttribute('src'),
                };
            },
        },
    ],
    renderHTML({ node }) {
        const { src, id, type } = node.attrs;
        if (!src)
            return null;
        const tag = (type === null || type === void 0 ? void 0 : type.includes('audio')) ? 'audio' : 'video';
        return [
            'figure',
            {
                'data-type': tag,
                'data-file-type': type,
                'data-id': id,
            },
            [
                tag,
                mergeAttributes({
                    'data-id': id,
                    controls: true,
                    src,
                }),
                `Your browser does not support the ${tag} element.`,
            ],
        ];
    },
    addNodeView() {
        return ReactNodeViewRenderer(VideoComponent);
    },
    addCommands() {
        return {
            setVideo: attrs => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    attrs,
                });
            },
            setVideoAttributes: attributes => ({ commands }) => commands.updateAttributes(this.name, attributes),
        };
    },
});
//# sourceMappingURL=index.js.map